import React from 'react'; // eslint-disable-line
import moment from 'moment-timezone';
import CloseModal from '../../components/svg/CloseModal';
import Clock from '../../components/svg/Clock';
import Calendar from '../../components/svg/Calendar';

const MessagesView = (props) => {
    return (
        <div className={`dialog-overlay ${props.Visible ? 'dialog-show' : 'dialog-hide'}`}>
            <div data-qa="messages-view-modal" className="message-modal message-view dialog-content">
                {/* eslint-disable-next-line */}
                <a data-qa="messages-view-modal-close" className="close-dialog" onClick={props.close}>
                    <CloseModal />
                    <span className="tooltipText">Close</span>
                </a>
                <div>
                    <h3>Message</h3>
                </div>
                <div data-qa="messages-view-modal-title" className="message-title">{props.messages.subject}</div>
                <div data-qa="messages-view-modal-body" className="message-body">{props.messages.body}</div>
                {props.messages.formTitle && (
                    <div data-qa="messages-view-modal-event-info" className="sent-form">
                        Sent to Registrants of:
                        <span className="form-title">{props.messages.formTitle}</span>
                    </div>
                )}
                <div data-qa="messages-view-modal-sent" className="sent">
                    {props.history ? 'Sent On' : 'Send On'}
                    {' '}
                    <Calendar />
                    <span className="message-date">
                        {moment(`${props.messages.scheduledTime}Z`).utc().tz(moment.tz.guess())
                            .format('MMM DD YYYY')}
                    </span>
                    <Clock />
                    <span className="message-time">
                        {moment(`${props.messages.scheduledTime}Z`).utc().tz(moment.tz.guess())
                            .format('hh:mm a z')}
                    </span>
                </div>

            </div>
        </div>
    );
};

export default MessagesView;
